// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picker-container[data-v-355c81c4] {\n  position: absolute;\n  background-color: white !important;\n  padding: 10px;\n  border-radius: 5px;\n  height: 420px;\n  width: 332px;\n  overflow-y: scroll;\n}\n.sticker[data-v-355c81c4] {\n  max-height: 100px;\n  max-width: 100px;\n  cursor: pointer;\n}\n.grid-container[data-v-355c81c4] {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  row-gap: 10px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
